import React, { useEffect, useState } from "react";
import Card from "../../../user/components/Card";
import { getStreamProducts, getStreamDetails } from "../../services/stream.service.js";
import { SOCKET_CLIENT } from "../../../../utils/socket";
import { SOCKET_EVENTS } from "../../../../utils/Constants";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSellerProfileUrl } from "../../../../utils/commonfunction";

function StreamDetails() {
  const { t } = useTranslation();
  const { id } = useParams(); // stream_id from URL
  const [stream, setStream] = useState(null);
  const [products, setProducts] = useState([]);
  const [totalViewers, setTotalViewers] = useState(0);
  const [totalLikes, setTotalLikes] = useState(0);
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function getUniqueAuthorCount(stream) {
  if (
    !stream ||
    !stream.twitch ||
    !stream.twitch.comments ||
    stream.twitch.comments.length === 0
  ) {
    return 0;
  }

  const comments = stream.twitch.comments;

  const uniqueAuthors = {};

  for (let i = 0; i < comments.length; i++) {
    const author = comments[i].author;

    // mark author as seen
    if (!uniqueAuthors[author]) {
      uniqueAuthors[author] = true;
    }
  }

  // count keys manually (no Object.keys shortcut)
  let count = 0;
  for (let key in uniqueAuthors) {
    count++;
  }

  return count;
}
const count = getUniqueAuthorCount(stream);
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const [streamRes, productRes] = await Promise.all([
          getStreamDetails(id),
          getStreamProducts({ stream_id: id }),
        ]);

        if (streamRes.success) {
          setStream(streamRes?.data);
          setTotalViewers(streamRes?.data?.listOfViewers?.length || 0);
          setTotalLikes(streamRes?.data?.listOfLikedUsers?.length || 0);
          console.log(streamRes, "streamRes");

        }

        if (productRes.success) {
          setProducts(productRes.data || []);
        }

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    const joinRooms = () => {
      SOCKET_CLIENT.emit("join_stream_room", id);
      SOCKET_CLIENT.emit(SOCKET_EVENTS.JOIN_STREAM, {
        streamID: id,
        userId: "advertiser_view", // generic
        role: "advertiser"
      });
    };

    if (SOCKET_CLIENT.connected) joinRooms();
    SOCKET_CLIENT.on("connect", joinRooms);

    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_VIEWER_COUNT, (data) => {
      console.log("STREAM_VIEWER_COUNT received:", data);
      setTotalViewers(data?.totalDbViews !== undefined ? data.totalDbViews : data?.totalViewers);
      setTotalLikes(data?.totalLikes);
    });

    SOCKET_CLIENT.on(SOCKET_EVENTS.STREAM_LIKE_UPDATE, (data) => {
      setTotalLikes(data?.totalLikes);
    });

    return () => {
      SOCKET_CLIENT.off("connect", joinRooms);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_VIEWER_COUNT);
      SOCKET_CLIENT.off(SOCKET_EVENTS.STREAM_LIKE_UPDATE);
    };
  }, [id]);
  useEffect(() => {
    console.log("Updated stream:", stream);
  }, [stream]);
  const handleViewStream = (item) => {
    const sellerId = item?.seller_id || item?.seller?._id || (typeof item?.seller === "string" ? item?.seller : undefined);
    navigate(`/user/live-streams/${sellerId}/${item.room_id}/${item._id}`);
  };
  return (
    <>
      <div className="stream-details-bg py-8 md:py-10">
        <div className="container">
          <div className="space-y-6">
            {/* --- Product Showcase Details Section --- */}
            <div className="bg-white p-[15px] md:p-[30px] rounded-[10px] shadow-[0px_2px_24px_0px_rgba(0,0,0,0.05)] border-1 !border-zinc-100">
              {/* Header and View Recording Button */}
              <div className="flex justify-between items-start mb-3 flex-wrap gap-[10px]">
                <div className="flex flex-col gap-[8px]">
                  <h2 className="headings-h2 text-zinc-950">
                    {stream?.title}
                  </h2>
                  <span className="text-[14px]">
                    Store :{" "}
                    {stream?.seller?.store_name ? (
                      <Link
                        to={getSellerProfileUrl(stream?.seller || { _id: stream?.seller_id, store_name: stream?.seller?.store_name })}
                        className="text-[#FF63B5] hover:underline font-semibold transition-colors cursor-pointer"
                      >
                        {stream.seller.store_name}
                      </Link>
                    ) : (
                      "N/A"
                    )}
                  </span>
                  {/* {stream?.category?.title && (
                    <span className="text-[14px] text-zinc-500">
                      Category : {stream.category.title}
                    </span>
                  )} */}
                  {stream?.seller?.businessCategories?.length > 0 && (
                    <span className="text-[14px] text-zinc-500">
                      Business Categories : {stream.seller.businessCategories.join(", ")}
                    </span>
                  )}
                  <p className="body-md text-zinc-500 !p-0 !m-0">
                    {stream?.date
                      ? new Date(stream.date).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                        hour12: true,   // 👈 IMPORTANT
                      })
                      : ""}

                  </p>
                  <p className="body-md text-zinc-500 !p-0 !m-0">
                    {t("streams.duration_minutes", { duration: stream?.duration })}
                  </p>
                </div>
                {/* {stream?.isStreamCompleted && (
                  <button disabled={!stream?.recording_url} onClick={() => handleViewStream(stream)} className="btn btn-pri !bg-[#FF63B5] !border-[#FF63B5] disabled:opacity-50 disabled:cursor-not-allowed">
                    {t("streams.rewatch")}
                  </button>
                )} */}
              </div>

              {/* Engagement Metrics */}
              <div className="flex gap-[15px] flex-wrap">
                {/* Likes */}
                <div className="flex items-center space-x-1 p-2 bg-white border rounded-lg text-gray-700 rounded-full">
                  <img src="/images/heart01.svg" alt="heart" />
                  <span className="text-zinc-950 text-[16px]">{t("streams.likes_count", { count: totalLikes })}</span>
                </div>

                {/* Live Viewers (Example 1) */}
                <div className="flex items-center space-x-1 p-2 bg-white border rounded-lg text-gray-700 rounded-full">
                  <img src="/images/eye01.svg" alt="eye" />
                  <span className="text-zinc-950 text-[16px]">{t("streams.views_count", { count: totalViewers })}</span>
                </div>

                {/* Total Leads */}
                <div className="flex items-center space-x-1 p-2 bg-white border rounded-lg text-gray-700 rounded-full">
                  <img src="/images/user01.svg" alt="user" />
                  <span className="text-zinc-950 text-[16px]">{t("streams.leads_count", { count: stream?.totalLeads || 0 })}</span>
                </div>
              </div>
            </div>

            {/* --- Social Media Section --- */}
            <div className="p-6 bg-gray-50 rounded-[16px]">
              <h3 className="body-lg text-zinc-500 mb-3">{t("streams.social_media")}</h3>

              <div className="flex flex-wrap gap-[15px]">
                {/* Twitch */}
                <div className="flex items-center gap-[10px] p-2 bg-white border !border-zinc-100 rounded-[10px] text-gray-700 hover:shadow-md transition duration-150">
                  <img className="w-[30px] h-[30px]" src="/images/twitch.png" alt="facebook" />
                  <span className="body-lg text-zinc-500">{t("streams.views_count", { count: stream?.twitchViews ? stream?.twitchViews : count })}</span>
                </div>

                {/* Facebook */}
                <div className="flex items-center gap-[10px] p-2 bg-white border !border-zinc-100 rounded-[10px] text-gray-700 hover:shadow-md transition duration-150">
                  <img src="/images/s-icon02.svg" alt="facebook" />
                  <span className="body-lg text-zinc-500">{t("streams.views_count", { count: stream?.facebookViews })}</span>
                </div>

                {/* YouTube */}
                <div className="flex items-center gap-[10px] p-2 bg-white border !border-zinc-100 rounded-[10px] text-gray-700 hover:shadow-md transition duration-150">
                  <img src="/images/s-icon03.svg" alt="youtube" />
                  <span className="body-lg text-zinc-500">{t("streams.views_count", { count: stream?.youtubeViews })}</span>
                </div>
              </div>

              {/* Comments Section */}
              <div className="mt-6">
                <h3 className="body-lg text-zinc-500 mb-3">{t("streams.social_media_comments")}</h3>
                {(!stream?.facebook?.comments?.length && !stream?.youtube?.comments?.length && !stream?.twitch?.comments?.length) ? (
                    <p className="text-gray-400 text-sm">{t("streams.no_comments_syncing")}</p>
                ) : (
                    <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
                        {/* YouTube Comments */}
                        {stream?.youtube?.comments?.map((comment, index) => (
                            <div key={`yt-${index}`} className="flex items-start gap-3 bg-white p-3 rounded-lg border border-red-100">
                                <img src="/images/s-icon03.svg" alt="youtube" className="w-5 h-5 mt-1" />
                                <div>
                                    <p className="text-sm font-semibold text-zinc-800">{comment.author}</p>
                                    <p className="text-sm text-zinc-600">{comment.text}</p>
                                </div>
                            </div>
                        ))}
                        {/* Facebook Comments */}
                        {stream?.facebook?.comments?.map((comment, index) => (
                            <div key={`fb-${index}`} className="flex items-start gap-3 bg-white p-3 rounded-lg border border-blue-100">
                                <img src="/images/s-icon02.svg" alt="facebook" className="w-5 h-5 mt-1" />
                                <div>
                                    <p className="text-sm font-semibold text-zinc-800">{comment.author}</p>
                                    <p className="text-sm text-zinc-600">{comment.text}</p>
                                </div>
                            </div>
                        ))}
                        {/* Twitch Comments (If any support added later) */}
                        {stream?.twitch?.comments?.map((comment, index) => (
                            <div key={`tw-${index}`} className="flex items-start gap-3 bg-white p-3 rounded-lg border border-purple-100">
                            <img className="w-[25px] h-[25px]" src="/images/twitch.png" alt="facebook" />
                                <div>
                                    <p className="text-sm font-semibold text-zinc-800">{comment.author}</p>
                                    <p className="text-sm text-zinc-600">{comment.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
              </div>
            </div>
          </div>

          <div className="associated-products-bg py-8 pb-0">
            <div className="associated-head mb-3">
              <h2 className="headings-h2 text-zinc-950">{t("streams.associated_products")}</h2>
            </div>

            {loading ? (
              <div className="flex items-center justify-center min-h-[400px]">
                <div className="flex flex-col items-center gap-4">
                  <div className="w-16 h-16 border-4 border-[#FF63B5] border-t-transparent rounded-full animate-spin"></div>
                  <p className="text-gray-600 text-lg">{t("streams.loading_products")}</p>
                </div>
              </div>
            ) : products.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                {products?.map((item) => (
                  <div className="cursor-pointer" onClick={() => navigate(`/advertiser/product-details?o_id=${item?._id}`)} >
                    <Card
                      key={item._id}
                      images={item?.image}
                      title={item.title}
                      price={item.price}
                      subtitle={item.description}
                    // editDelete
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-10">
                <p className="text-gray-500">
                  {t("streams.no_associated_products")}
                </p>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
}

export default StreamDetails;
